import request from '@/utils/request'


export function getUserPage(current,size) {
  return request({
    url: '/system/sysUser/page',
    method: 'GET',
    params: { current,size }
  })
}
export function getUserPageNew(params) {
  return request({
    url: '/system/sysUser/page',
    method: 'GET',
    params: params
  })
}

//initEncrypt
export function initEncrypt() {
  return request({
    url: '/system/encryptUserPassword',
    method: 'GET'
  })
}

export function userHmac() {
  return request({
    url: '/system/userHmac',
    method: 'GET'
  })
}

export function addUser(data) {
  return request({
    url: '/system/sysUser',
    method: 'POST',
    data:data
  })
}

export function getUser(id) {
  return request({
    url: `/system/sysUser/${id}`,
    method: 'GET',
   
  })
}

export function resetPass(params) {
  return request({
    url: '/system/resetPass',
    method: 'PATCH',
    params: params
  })
}

export function deleteUser(id) {
  return request({
    url: '/system/sysUserDel',
    method: 'get',
    params: {id:id}
   
  })
}

export function updateUser(data) {
  return request({
    url: '/system/sysUser',
    method: 'PATCH',
    data:data
   
  })
}

export function selectUser(current,size,loginName,name) {
  return request({
    url: '/system/sysUser/page',
    method: 'GET',
    params: { current,size,loginName,name}
   
  })
}
export function updatePassNoLogin(userId,code,pass){
  return request({
    url: '/system/updatePassNoLogin',
    method: 'PATCH',
    params:{
      userId:userId,
      code:code,
      pass:pass
    }
   
  })
}


export function pwdWeakUpdate(loginName,password,newPassword){
  return request({
    url: '/system/pwdWeakUpdate',
    method: 'PATCH',
    params:{
      loginName:loginName,
      password:password,
      newPassword:newPassword
    }
   
  })
}



export function userUnlock(loginName,mobile,smsCode){
  return request({
    url: '/selfUnlock',
    method: 'POST',
    params:{
      loginName:loginName,
      mobile:mobile,
      code:smsCode
    }
   
  })
}